import { Batch } from "@/services/backend/batches/batch/batch";
import { formatDate } from "@/shared/utilities/date";
import { de } from "date-fns/locale";

interface BatchComponentProps {
  batch?: Batch;
}

export function BatchComponent({ batch }: BatchComponentProps) {
  if (batch != null && batch.batchNumber !== "")
    return (
      <span>{`Nummer: ${batch.batchNumber} - ${formatDate(batch.expiryDate, de)}`}</span>
    );
  return <span>Keine Charge gefunden</span>;
}
